import {
  isMobileAtom,
  isSidebarOpenAtom,
  toggleSidebarAtom,
} from "@/hooks/useFrame";
import { Button } from "@/shadcn/ui/button";
import { useAtomValue } from "jotai";
import { useSetAtom } from "jotai/react";
import { Link, useLocation } from "react-router-dom";

import { SearchBar } from "./searchbar/components/SearchBar";
import clsx from "clsx";
import { Logo } from "./Logo";
import { useState } from "react";
import { UserMenu } from "./userMenu/components/UserMenu";

interface HeaderProps extends React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLElement>,
  HTMLElement
> {
  id: string;
}

export function Header({ id }: HeaderProps) {
  const frameToggleSidebar = useSetAtom(toggleSidebarAtom);
  const isSidebarOpen = useAtomValue(isSidebarOpenAtom);
  const isMobile = useAtomValue(isMobileAtom);
  const [isSearching, setIsSearching] = useState(false);
  const path = useLocation().pathname;

  return (
    <header id={id} className="flex items-center gap-1 px-2">
      <Button
        size="icon"
        variant="ghost"
        className="h-12 w-12 p-4"
        onClick={frameToggleSidebar}
      >
        <div className="i-heroicons:bars-3 rounded-md p-3" />
      </Button>

      {!isSearching && (
        <Button
          size="icon"
          variant="link"
          className={clsx(
            "hover: h-12 w-12 p-0 opacity-100 transition-all duration-1000 starting:-translate-y-6 starting:opacity-0",
            isSidebarOpen && "hidden",
          )}
          asChild
        >
          <Link to="/">
            <Logo className="h-8 w-8" />
          </Link>
        </Button>
      )}

      <div className="hidden grow md:flex" />

      {path !== "/search" && (
        <>
          {/* Mobile-specific search bar */}
          {isMobile &&
            (isSearching ? (
              <div className="mt-3 flex w-full items-start self-start">
                <SearchBar className="shrink grow" autoFocus />
                <Button
                  size="icon"
                  variant="ghost"
                  className="ml-2 text-lg"
                  onClick={() => setIsSearching(false)}
                >
                  <div className="i-lucide:x h-8 w-8" />
                </Button>
              </div>
            ) : (
              <Button
                size="icon"
                variant="ghost"
                className="ml-auto h-12 w-12 text-xl"
                onClick={() => setIsSearching(true)}
              >
                <div className="i-heroicons:magnifying-glass h-8 w-8" />
              </Button>
            ))}

          {/* Desktop-specific search bar */}
          {!isMobile && (
            <SearchBar className="mt-3 max-w-lg self-start md:mr-1 lg:mr-2" />
          )}
        </>
      )}

      {!isSearching && <UserMenu />}
    </header>
  );
}
